import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import  Store  from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router} from "react-router-dom";
import ScrollToTop from "./utils/scrollToTop"
ReactDOM.render(
  
  <React.StrictMode>
    <Provider store={Store}>
      <Router>
        <ScrollToTop/>
      <App />
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
